import {
    baseTheme,
    Caption,
    Flex,
    Provider,
    pxArrayToRem,
    disableBodyScroll,
    clearAllBodyScrollLocks,
} from '@archipro-design/aria';
import { useStyles, Button } from '@archipro-design/aria';
import { CloseLine } from '@archipro-design/icons';
import * as S from './FilterContainer.mobile.style';
import type { FilterContainerProps } from '~/modules/search/components/filter-drawer/FilterContainer';
import type { FilterSortByProps } from '~/modules/search/components/filter-drawer/FilterSortBy.mobile';
import FilterSortBy from '~/modules/search/components/filter-drawer/FilterSortBy.mobile';
import { useEffect, useRef } from 'react';
import FilterViewProjectsBy from '~/modules/search/components/filter-drawer/FilterViewProjectsBy.mobile';

const FilterContainerMobile = (
    props: FilterContainerProps & FilterSortByProps
) => {
    const {
        primaryButton,
        secondaryButton,
        onClose,
        disabled,
        children,
        onSortChange,
        sortOptions,
        viewProjectsByOptions,
        onViewProjectsByChange,
        category,
    } = props;
    const contentRef = useRef<HTMLDivElement>(null);
    const { css } = useStyles();

    useEffect(() => {
        if (!contentRef?.current) return;
        disableBodyScroll(contentRef.current);

        return () => {
            clearAllBodyScrollLocks();
        };
    }, [contentRef]);

    return (
        <Provider theme={baseTheme} className={css(S.RootContainer)}>
            <Flex className={css(S.TopHeaderContainer)}>
                <div className="clear">
                    {secondaryButton && (
                        <Button
                            transparent
                            size={14}
                            variables={{
                                buttonPadding: pxArrayToRem([4, 1, 0, 1]),
                            }}
                            {...{
                                ...secondaryButton,
                                children: 'Clear all',
                            }}
                            key="secondaryButton"
                            disabled={disabled}
                        />
                    )}
                </div>
                <Caption variant="03" weight="medium" className="title">
                    {category === 'blogpost' ? 'Sort by' : 'Filters'}
                </Caption>
                <div className="close">
                    <Button
                        disabled={disabled}
                        onClick={(e) => onClose?.(e)}
                        size={24}
                        color="dark"
                        transparent={true}
                        variables={{
                            buttonPadding: 0,
                            iconPadding: 0,
                        }}
                        icon={<CloseLine />}
                    />
                </div>
            </Flex>

            <div
                className={`${css(S.ContentContainer)} content-container`}
                ref={contentRef}
            >
                <FilterSortBy
                    sortOptions={sortOptions}
                    onSortChange={onSortChange}
                />
                {viewProjectsByOptions.length > 0 && (
                    <FilterViewProjectsBy
                        viewProjectsByOptions={viewProjectsByOptions}
                        onViewProjectsByChange={onViewProjectsByChange}
                    />
                )}
                {children}
            </div>

            {(primaryButton || secondaryButton) && (
                <div className={css(S.BottomButtonsContainer)}>
                    {primaryButton && (
                        <Button
                            size={16}
                            fluid
                            variables={{ buttonPadding: 16 }}
                            {...primaryButton}
                            key="primaryButton"
                            disabled={disabled}
                        />
                    )}
                </div>
            )}
        </Provider>
    );
};

export default FilterContainerMobile;
